module.exports = __webpack_public_path__ + "img/folder.349fb1ec.svg";